import { render, staticRenderFns } from "./LineStopSyncCreatePage.vue?vue&type=template&id=5ae8ed42&scoped=true&"
import script from "./LineStopSyncCreatePage.vue?vue&type=script&lang=ts&"
export * from "./LineStopSyncCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae8ed42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol})
